import React, { Fragment } from "react";

const IndustryImageDescriptionItem = ({ episode: { currentepisode } }) => {
  return (
    <Fragment>
      <div className="selected-week-image-container">
        <img
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/industry_of_week_images/${currentepisode.industryimage}`}
          className="selected-industry-company-image"
          alt="imagedescription"
        />
      </div>
      <div className="weekly-description">
        <div className="flex-center">
          <p className="weekly-title">
            {currentepisode && currentepisode.industrydescriptionname}
          </p>
        </div>
        <p className="weekly-paragraph" id="green-scroll">
          {currentepisode && currentepisode.description}
        </p>
      </div>
    </Fragment>
  );
};

export default IndustryImageDescriptionItem;
